import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Slide from '@material-ui/core/Slide';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { AppName, glassmorphism, blur } from '../../AppConfig';
import ScrollToTop from './ScrollToTop';

const useStyles = makeStyles(() => ({
  appBar: {
    backdropFilter: glassmorphism === true ? 'blur('+blur+')' : null,
    height: 54,
    display: 'grid',
    placeItems: 'center',
    margin: '12px',
    width: 'calc(100vw - 24px)',
    borderRadius: 8,
    '& > *': {
      display: 'grid',
      placeItems: 'center',
    }
  }
}));

function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: false,
    threshold: 300
  });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired
};

function HeaderAppBar(props) {
const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar color="inherit" className={classes.appBar}>
          <Toolbar variant="dense" style={{width: '100%'}}>
            <Typography variant="h6">{AppName} &#127798;</Typography>
            <ScrollToTop />
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar />
    </React.Fragment>
  );
}
export default HeaderAppBar;